<template>
  <div class="scientific-article">

    <product-popup @closePopup="closePopup()" :productInfo="productInfo" v-if="isProductInfoOpen"/>

    <a id="viber_share" style="display: none;" href=""></a>

    <div class="article-header">
      <div class="article-type">Довідковий матеріал</div>
    </div>

    <div class="article-content">

      <div class="article-title">
        <div class="image">
          <svg width="64" height="87" viewBox="0 0 64 87" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M56 2.23808C56 1.6092 55.409 1.14775 54.7989 1.30028L8.73221 12.8169C8.30188 12.9245 8 13.3112 8 13.7548V73.0333C8 73.5672 8.43279 74 8.96667 74H55.0333C55.5672 74 56 73.5672 56 73.0333V2.23808Z" fill="#DCCFEB"/>
            <path d="M56 1H5C2.23858 1 0 3.23858 0 6V69C0 71.7614 2.23857 74 5 74H7.5V12.5L56 1Z" fill="#CEBFE0"/>
            <path d="M7 13.9667C7 13.4328 7.43279 13 7.96667 13H59C61.2091 13 63 14.7909 63 17V82C63 84.2091 61.2091 86 59 86H7.96667C7.43279 86 7 85.5672 7 85.0333V13.9667Z" fill="#F1EDF7"/>
            <path opacity="0.7" d="M17.2388 26.3701H17.5146C17.7507 25.8981 17.937 25.4269 18.0737 24.9565C18.2104 24.4845 18.3122 23.9759 18.3789 23.4307H20.459V26.3701H20.9351V28.04H20.2051V27H17.9688V28.04H17.2388V26.3701ZM18.9795 24.0605C18.9274 24.4333 18.8403 24.828 18.7183 25.2446C18.5978 25.6613 18.4619 26.0365 18.3105 26.3701H19.7046V24.0605H18.9795ZM24.7266 25.2104C24.7266 25.8013 24.5801 26.2554 24.2871 26.5728C23.9941 26.8901 23.5742 27.0488 23.0273 27.0488C22.4805 27.0488 22.0605 26.8901 21.7676 26.5728C21.4746 26.2554 21.3281 25.7996 21.3281 25.2056C21.3281 24.6115 21.4746 24.1582 21.7676 23.8457C22.0622 23.5316 22.4837 23.3745 23.0322 23.3745C23.5807 23.3745 23.9998 23.5324 24.2896 23.8481C24.5809 24.1639 24.7266 24.618 24.7266 25.2104ZM22.1216 25.2104C22.1216 25.6092 22.1973 25.9095 22.3486 26.1113C22.5 26.3132 22.7262 26.4141 23.0273 26.4141C23.6312 26.4141 23.9331 26.0129 23.9331 25.2104C23.9331 24.4064 23.6328 24.0044 23.0322 24.0044C22.7311 24.0044 22.5041 24.1061 22.3511 24.3096C22.1981 24.5114 22.1216 24.8117 22.1216 25.2104ZM25.4663 23.4307H26.5771C27.0833 23.4307 27.4504 23.5031 27.6782 23.6479C27.9077 23.7912 28.0225 24.0199 28.0225 24.334C28.0225 24.5472 27.972 24.7222 27.8711 24.8589C27.7718 24.9956 27.6392 25.0778 27.4731 25.1055V25.1299C27.6994 25.1803 27.8621 25.2747 27.9614 25.4131C28.0623 25.5514 28.1128 25.7354 28.1128 25.9648C28.1128 26.2904 27.9948 26.5443 27.7588 26.7266C27.5244 26.9089 27.2054 27 26.8018 27H25.4663V23.4307ZM26.2231 24.8442H26.6626C26.8677 24.8442 27.0158 24.8125 27.1069 24.749C27.1997 24.6855 27.2461 24.5806 27.2461 24.4341C27.2461 24.2974 27.1956 24.1997 27.0947 24.1411C26.9954 24.0809 26.8376 24.0508 26.6211 24.0508H26.2231V24.8442ZM26.2231 25.4448V26.375H26.7163C26.9246 26.375 27.0785 26.3351 27.1777 26.2554C27.277 26.1756 27.3267 26.0535 27.3267 25.8892C27.3267 25.5929 27.1151 25.4448 26.6919 25.4448H26.2231ZM28.8257 27V23.4307H29.5825V27H28.8257ZM30.0562 26.3701H30.332C30.568 25.8981 30.7544 25.4269 30.8911 24.9565C31.0278 24.4845 31.1296 23.9759 31.1963 23.4307H33.2764V26.3701H33.7524V28.04H33.0225V27H30.7861V28.04H30.0562V26.3701ZM31.7969 24.0605C31.7448 24.4333 31.6577 24.828 31.5356 25.2446C31.4152 25.6613 31.2793 26.0365 31.1279 26.3701H32.522V24.0605H31.7969ZM37.2144 27H36.355L35.061 25.1909V27H34.3042V23.4307H35.061V25.1592L36.3403 23.4307H37.146L35.8447 25.1445L37.2144 27ZM40.9033 25.2104C40.9033 25.8013 40.7568 26.2554 40.4639 26.5728C40.1709 26.8901 39.751 27.0488 39.2041 27.0488C38.6572 27.0488 38.2373 26.8901 37.9443 26.5728C37.6514 26.2554 37.5049 25.7996 37.5049 25.2056C37.5049 24.6115 37.6514 24.1582 37.9443 23.8457C38.2389 23.5316 38.6605 23.3745 39.209 23.3745C39.7575 23.3745 40.1766 23.5324 40.4663 23.8481C40.7576 24.1639 40.9033 24.618 40.9033 25.2104ZM38.2983 25.2104C38.2983 25.6092 38.374 25.9095 38.5254 26.1113C38.6768 26.3132 38.903 26.4141 39.2041 26.4141C39.8079 26.4141 40.1099 26.0129 40.1099 25.2104C40.1099 24.4064 39.8096 24.0044 39.209 24.0044C38.9079 24.0044 38.6808 24.1061 38.5278 24.3096C38.3748 24.5114 38.2983 24.8117 38.2983 25.2104ZM41.6431 23.4307H42.7539C43.2601 23.4307 43.6271 23.5031 43.855 23.6479C44.0845 23.7912 44.1992 24.0199 44.1992 24.334C44.1992 24.5472 44.1488 24.7222 44.0479 24.8589C43.9486 24.9956 43.8159 25.0778 43.6499 25.1055V25.1299C43.8761 25.1803 44.0389 25.2747 44.1382 25.4131C44.2391 25.5514 44.2896 25.7354 44.2896 25.9648C44.2896 26.2904 44.1715 26.5443 43.9355 26.7266C43.7012 26.9089 43.3822 27 42.9785 27H41.6431V23.4307ZM42.3999 24.8442H42.8394C43.0444 24.8442 43.1925 24.8125 43.2837 24.749C43.3765 24.6855 43.4229 24.5806 43.4229 24.4341C43.4229 24.2974 43.3724 24.1997 43.2715 24.1411C43.1722 24.0809 43.0143 24.0508 42.7979 24.0508H42.3999V24.8442ZM42.3999 25.4448V26.375H42.8931C43.1014 26.375 43.2552 26.3351 43.3545 26.2554C43.4538 26.1756 43.5034 26.0535 43.5034 25.8892C43.5034 25.5929 43.2918 25.4448 42.8687 25.4448H42.3999ZM45.0024 23.4307H45.6836V25.1543L45.6738 25.6157L45.6494 26.1406H45.6641L47.312 23.4307H48.2178V27H47.5439V25.2861C47.5439 25.0566 47.5586 24.7165 47.5879 24.2656H47.5684L45.9131 27H45.0024V23.4307ZM49.1187 23.4307H49.7998V25.1543L49.79 25.6157L49.7656 26.1406H49.7803L51.4282 23.4307H52.334V27H51.6602V25.2861C51.6602 25.0566 51.6748 24.7165 51.7041 24.2656H51.6846L50.0293 27H49.1187V23.4307ZM51.9092 22.271C51.8783 22.5754 51.7635 22.7975 51.5649 22.9375C51.3664 23.0758 51.0799 23.145 50.7056 23.145C50.3198 23.145 50.0342 23.0783 49.8486 22.9448C49.6647 22.8114 49.5614 22.5868 49.5386 22.271H50.2051C50.2165 22.4386 50.258 22.5566 50.3296 22.625C50.4028 22.6917 50.533 22.7251 50.7202 22.7251C50.8846 22.7251 51.0067 22.6885 51.0864 22.6152C51.1678 22.5404 51.2174 22.4256 51.2354 22.271H51.9092ZM24.0405 33L23.1812 30.1997H23.1592C23.1901 30.7694 23.2056 31.1494 23.2056 31.3398V33H22.5293V29.4307H23.5596L24.4043 32.1602H24.4189L25.3149 29.4307H26.3452V33H25.6396V31.3105C25.6396 31.2308 25.6405 31.1388 25.6421 31.0347C25.6453 30.9305 25.6567 30.6538 25.6763 30.2046H25.6543L24.7339 33H24.0405ZM29.4312 33L29.1724 32.1504H27.8711L27.6123 33H26.7969L28.0566 29.416H28.9819L30.2466 33H29.4312ZM28.9917 31.5156C28.7524 30.7458 28.6174 30.3104 28.5864 30.2095C28.5571 30.1086 28.536 30.0288 28.5229 29.9702C28.4692 30.1785 28.3154 30.6937 28.0615 31.5156H28.9917ZM32.0752 33H31.3184V30.0605H30.3491V29.4307H33.0444V30.0605H32.0752V33ZM35.6494 33H33.5938V29.4307H35.6494V30.0508H34.3506V30.8345H35.5591V31.4546H34.3506V32.375H35.6494V33ZM37.1533 31.1104H37.4023C37.6351 31.1104 37.8092 31.0648 37.9248 30.9736C38.0404 30.8809 38.0981 30.7466 38.0981 30.5708C38.0981 30.3934 38.0493 30.2624 37.9517 30.1777C37.8556 30.0931 37.7043 30.0508 37.4976 30.0508H37.1533V31.1104ZM38.8623 30.5439C38.8623 30.9281 38.7419 31.2218 38.501 31.4253C38.2617 31.6287 37.9207 31.7305 37.478 31.7305H37.1533V33H36.3965V29.4307H37.5366C37.9696 29.4307 38.2983 29.5243 38.5229 29.7114C38.7492 29.897 38.8623 30.1745 38.8623 30.5439ZM39.5361 33V29.4307H40.293V33H39.5361ZM43.3765 33L43.1177 32.1504H41.8164L41.5576 33H40.7422L42.002 29.416H42.9272L44.1919 33H43.3765ZM42.937 31.5156C42.6978 30.7458 42.5627 30.3104 42.5317 30.2095C42.5024 30.1086 42.4813 30.0288 42.4683 29.9702C42.4146 30.1785 42.2607 30.6937 42.0068 31.5156H42.937ZM47.4683 33H46.7139V30.0605H45.8398L45.8008 30.3877C45.6999 31.2194 45.6104 31.8037 45.5322 32.1406C45.4557 32.4759 45.3434 32.7119 45.1953 32.8486C45.0472 32.9854 44.847 33.0521 44.5947 33.0488C44.458 33.0488 44.3376 33.0309 44.2334 32.9951V32.375C44.3278 32.4076 44.4165 32.4238 44.4995 32.4238C44.5858 32.4238 44.6541 32.3848 44.7046 32.3066C44.755 32.2269 44.8022 32.0804 44.8462 31.8672C44.8918 31.6523 44.9512 31.3016 45.0244 30.8149C45.0993 30.3267 45.1628 29.8652 45.2148 29.4307H47.4683V33Z" fill="#8F67A4"/>
            <path d="M64 80.7219V18.4769C64 15.0586 61.2377 12.2435 57.8295 12.1988H57.4953V0H6.25966C2.80682 0 0 2.8151 0 6.27812V68.5231C0 71.9415 2.76227 74.7565 6.17055 74.8012H6.5047V87H57.7181C61.1932 87 64 84.1849 64 80.7219ZM6.5047 73.2596L6.14828 73.2373C3.40828 73.1256 1.24748 70.8914 1.24748 68.1433V6.65794C1.24748 3.84283 3.54194 1.5416 6.34876 1.5416H51.3025L6.5047 12.1094V73.2596ZM55.9582 2.01079L55.9137 12.1988H13.1208L55.9582 2.01079ZM7.77445 85.4584V13.7404H57.6512C60.4581 13.7404 62.7525 16.0416 62.7525 18.8567V80.3644C62.7525 83.1795 60.4581 85.4807 57.6512 85.4807H7.77445V85.4584Z" fill="#AC98C5"/>
            <path opacity="0.7" d="M47.7692 41H22.2305C21.5512 41 21 41.6917 21 42.5408V74.4593C21 74.9811 21.2088 75.4409 21.5272 75.7201V75.963H21.9683C22.0528 75.9862 22.1402 76 22.2305 76H47.7692C47.8587 76 47.9458 75.9862 48.0305 75.963H48.091V75.9398C48.6128 75.761 49 75.1682 49 74.4593V42.5413C49.0001 41.6917 48.4475 41 47.7692 41ZM29.8056 74.6421H21.9814V70.4592H29.8056V74.6421ZM29.8056 69.1383H21.9814V64.8003H29.8056V69.1383ZM29.8056 63.4799H21.9814V58.9H29.8056V63.4799ZM29.8056 57.5792H21.9814V52.6251H29.8056V57.5792ZM29.8056 51.3043H21.9814V46.4604H29.8056V51.3043ZM38.7734 74.6421H30.8605V70.4592H38.7734V74.6421ZM38.7734 69.1383H30.8605V64.8003H38.7734V69.1383ZM38.7734 63.4799H30.8605V58.9H38.7734V63.4799ZM38.7734 57.5792H30.8605V52.6251H38.7734V57.5792ZM38.7734 51.3043H30.8605V46.4604H38.7734V51.3043ZM47.9451 74.4593C47.9451 74.5373 47.9097 74.6033 47.8604 74.642H39.8283V70.4591H47.9451V74.4593ZM47.9451 69.1383H39.8283V64.8003H47.9451V69.1383ZM47.9451 63.4799H39.8283V58.9H47.9451V63.4799ZM47.9451 57.5792H39.8283V52.6251H47.9451V57.5792ZM47.9451 51.3043H39.8283V46.4604H47.9451V51.3043Z" fill="#8F67A4"/>
          </svg>
        </div>
        <div class="title">
          {{ articleItem.title }}
        </div>
      </div>

      <div class="usefull-info" v-if="articleItem.useful">
        Корисно для пацієнтів
      </div>

      <div class="recomendations">
        <div class="year">
          <div class="icon">
            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.45 4.97982V14.4588H1.55V4.97982H13.45ZM13.75 1.93246H12.55V1.24561C12.55 1.08134 12.415 0.95 12.25 0.95H10.5C10.335 0.95 10.2 1.08134 10.2 1.24561V1.93246H4.8V1.24561C4.8 1.08134 4.66503 0.95 4.5 0.95H2.75C2.58497 0.95 2.45 1.08134 2.45 1.24561V1.93246H1.25C1.08497 1.93246 0.95 2.0638 0.95 2.22807V4.68421V15V15.05H1H1.00001H1.00002H1.00003H1.00005H1.00006H1.00008H1.0001H1.00013H1.00015H1.00018H1.00021H1.00025H1.00029H1.00032H1.00037H1.00041H1.00046H1.00051H1.00056H1.00061H1.00067H1.00073H1.00079H1.00085H1.00092H1.00099H1.00106H1.00113H1.00121H1.00129H1.00137H1.00145H1.00154H1.00163H1.00172H1.00181H1.00191H1.00201H1.00211H1.00221H1.00231H1.00242H1.00253H1.00264H1.00276H1.00288H1.003H1.00312H1.00324H1.00337H1.0035H1.00363H1.00376H1.0039H1.00404H1.00418H1.00432H1.00447H1.00461H1.00476H1.00492H1.00507H1.00523H1.00539H1.00555H1.00571H1.00588H1.00605H1.00622H1.00639H1.00657H1.00675H1.00693H1.00711H1.00729H1.00748H1.00767H1.00786H1.00805H1.00825H1.00845H1.00865H1.00885H1.00905H1.00926H1.00947H1.00968H1.0099H1.01011H1.01033H1.01055H1.01077H1.011H1.01122H1.01145H1.01168H1.01192H1.01215H1.01239H1.01263H1.01287H1.01312H1.01336H1.01361H1.01386H1.01412H1.01437H1.01463H1.01489H1.01515H1.01541H1.01568H1.01595H1.01622H1.01649H1.01676H1.01704H1.01732H1.0176H1.01788H1.01817H1.01845H1.01874H1.01903H1.01933H1.01962H1.01992H1.02022H1.02052H1.02082H1.02113H1.02144H1.02174H1.02206H1.02237H1.02269H1.023H1.02332H1.02364H1.02397H1.02429H1.02462H1.02495H1.02528H1.02562H1.02595H1.02629H1.02663H1.02697H1.02732H1.02766H1.02801H1.02836H1.02871H1.02907H1.02942H1.02978H1.03014H1.0305H1.03086H1.03123H1.0316H1.03196H1.03234H1.03271H1.03308H1.03346H1.03384H1.03422H1.0346H1.03499H1.03537H1.03576H1.03615H1.03654H1.03694H1.03733H1.03773H1.03813H1.03853H1.03894H1.03934H1.03975H1.04016H1.04057H1.04098H1.04139H1.04181H1.04223H1.04265H1.04307H1.04349H1.04392H1.04435H1.04478H1.04521H1.04564H1.04607H1.04651H1.04695H1.04739H1.04783H1.04827H1.04872H1.04916H1.04961H1.05006H1.05052H1.05097H1.05143H1.05188H1.05234H1.0528H1.05327H1.05373H1.0542H1.05466H1.05513H1.05561H1.05608H1.05655H1.05703H1.05751H1.05799H1.05847H1.05895H1.05944H1.05992H1.06041H1.0609H1.06139H1.06189H1.06238H1.06288H1.06338H1.06388H1.06438H1.06488H1.06539H1.06589H1.0664H1.06691H1.06742H1.06794H1.06845H1.06897H1.06949H1.07001H1.07053H1.07105H1.07157H1.0721H1.07263H1.07316H1.07369H1.07422H1.07475H1.07529H1.07583H1.07636H1.0769H1.07745H1.07799H1.07853H1.07908H1.07963H1.08018H1.08073H1.08128H1.08183H1.08239H1.08295H1.08351H1.08407H1.08463H1.08519H1.08575H1.08632H1.08689H1.08746H1.08803H1.0886H1.08917H1.08975H1.09032H1.0909H1.09148H1.09206H1.09264H1.09323H1.09381H1.0944H1.09499H1.09558H1.09617H1.09676H1.09735H1.09795H1.09855H1.09914H1.09974H1.10034H1.10095H1.10155H1.10215H1.10276H1.10337H1.10398H1.10459H1.1052H1.10581H1.10643H1.10704H1.10766H1.10828H1.1089H1.10952H1.11014H1.11077H1.11139H1.11202H1.11265H1.11328H1.11391H1.11454H1.11517H1.11581H1.11644H1.11708H1.11772H1.11836H1.119H1.11964H1.12029H1.12093H1.12158H1.12223H1.12287H1.12352H1.12418H1.12483H1.12548H1.12614H1.12679H1.12745H1.12811H1.12877H1.12943H1.13009H1.13076H1.13142H1.13209H1.13275H1.13342H1.13409H1.13476H1.13544H1.13611H1.13678H1.13746H1.13814H1.13881H1.13949H1.14017H1.14085H1.14154H1.14222H1.14291H1.14359H1.14428H1.14497H1.14566H1.14635H1.14704H1.14773H1.14843H1.14912H1.14982H1.15051H1.15121H1.15191H1.15261H1.15332H1.15402H1.15472H1.15543H1.15613H1.15684H1.15755H1.15826H1.15897H1.15968H1.16039H1.16111H1.16182H1.16254H1.16325H1.16397H1.16469H1.16541H1.16613H1.16685H1.16757H1.1683H1.16902H1.16975H1.17048H1.1712H1.17193H1.17266H1.17339H1.17412H1.17486H1.17559H1.17633H1.17706H1.1778H1.17854H1.17927H1.18001H1.18075H1.1815H1.18224H1.18298H1.18373H1.18447H1.18522H1.18596H1.18671H1.18746H1.18821H1.18896H1.18971H1.19047H1.19122H1.19197H1.19273H1.19349H1.19424H1.195H1.19576H1.19652H1.19728H1.19804H1.1988H1.19956H1.20033H1.20109H1.20186H1.20263H1.20339H1.20416H1.20493H1.2057H1.20647H1.20724H1.20801H1.20879H1.20956H1.21033H1.21111H1.21189H1.21266H1.21344H1.21422H1.215H1.21578H1.21656H1.21734H1.21812H1.21891H1.21969H1.22048H1.22126H1.22205H1.22283H1.22362H1.22441H1.2252H1.22599H1.22678H1.22757H1.22836H1.22915H1.22995H1.23074H1.23154H1.23233H1.23313H1.23393H1.23472H1.23552H1.23632H1.23712H1.23792H1.23872H1.23952H1.24032H1.24113H1.24193H1.24273H1.24354H1.24434H1.24515H1.24596H1.24676H1.24757H1.24838H1.24919H1.25L13.9151 15.05L13.9867 15.1304L13.9872 15.05H14.049L13.9876 14.9811L14.05 4.68451V4.68421V2.22807C14.05 2.0638 13.915 1.93246 13.75 1.93246ZM10.8 2.22807V1.54123H11.95V2.22807V2.91491H10.8V2.22807ZM3.05 2.22807V1.54123H4.2V2.22807V2.91491H3.05V2.22807ZM1.55 2.52368H2.45V3.21052C2.45 3.37479 2.58497 3.50614 2.75 3.50614H4.5C4.66503 3.50614 4.8 3.37479 4.8 3.21052V2.52368H10.2V3.21052C10.2 3.37479 10.335 3.50614 10.5 3.50614H12.25C12.415 3.50614 12.55 3.37479 12.55 3.21052V2.52368H13.45V4.38859H1.55V2.52368Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
            </svg>
          </div>
          <div class="text">
            {{ articleItem.publishYear }}
          </div>
        </div>
        <div class="images-conteainer">
          <div class="image-block" v-if="!includeIsPdf && articleItem.includeRation != null">
            <!--  -->
            <img :src="$root.globalUrl + articleItem.includeRation.name" alt="">
            <div class="action-buttons">
              <a :href="$root.globalUrl + articleItem.includeRation.name" download class="download">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 12.4436H12" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M6.46484 8.08519V1" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M9.68023 5.66956L6.46414 8.85293L3.24805 5.66956" stroke="white" stroke-width="1.5"
                        stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
                зберегти
              </a>
              <div class="send" @click="sendToServerScreen($root.globalUrl + articleItem.includeRation.name)">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.0315 9.02942L17.0622 8.99573L17.0315 8.96204L9.7397 0.966308L9.65276 0.87097V1V5.73955H8.85571C6.74419 5.73955 4.75869 6.56196 3.26555 8.0551C1.77241 9.54824 0.95 11.5337 0.95 13.6454V17V17.129L1.03693 17.0337L2.43635 15.5004C4.28757 13.4722 6.91073 12.2937 9.65276 12.253V16.9916V17.1206L9.7397 17.0253L17.0315 9.02942ZM15.658 8.99573L10.6903 14.443V11.2644V11.2144H10.6403H9.79907C6.86704 11.2144 4.04602 12.3946 1.98762 14.4673V13.6454C1.98762 11.8107 2.70196 10.086 3.99922 8.78877C5.29649 7.49151 7.02107 6.77717 8.85571 6.77717H10.6403H10.6903V6.72717V3.54858L15.658 8.99573Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
                </svg>
                надіслати
              </div>
            </div>
          </div>
          <div class="image-block" v-if="articleItem.excludeRation != null">
            <img :src="$root.globalUrl + articleItem.excludeRation.name != null ? articleItem.excludeRation.name : ''" alt="">
            <div class="action-buttons">
              <a :href="$root.globalUrl + articleItem.excludeRation.name != null ? articleItem.excludeRation.name : ''" download class="download">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 12.4436H12" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M6.46484 8.08519V1" stroke="white" stroke-width="1.5" stroke-miterlimit="10"
                        stroke-linecap="square" stroke-linejoin="round"/>
                  <path d="M9.68023 5.66956L6.46414 8.85293L3.24805 5.66956" stroke="white" stroke-width="1.5"
                        stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
                зберегти
              </a>
              <div class="send" @click="sendToServerScreen($root.globalUrl + articleItem.excludeRation.name)">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.0315 9.02942L17.0622 8.99573L17.0315 8.96204L9.7397 0.966308L9.65276 0.87097V1V5.73955H8.85571C6.74419 5.73955 4.75869 6.56196 3.26555 8.0551C1.77241 9.54824 0.95 11.5337 0.95 13.6454V17V17.129L1.03693 17.0337L2.43635 15.5004C4.28757 13.4722 6.91073 12.2937 9.65276 12.253V16.9916V17.1206L9.7397 17.0253L17.0315 9.02942ZM15.658 8.99573L10.6903 14.443V11.2644V11.2144H10.6403H9.79907C6.86704 11.2144 4.04602 12.3946 1.98762 14.4673V13.6454C1.98762 11.8107 2.70196 10.086 3.99922 8.78877C5.29649 7.49151 7.02107 6.77717 8.85571 6.77717H10.6403H10.6903V6.72717V3.54858L15.658 8.99573Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
                </svg>
                надіслати
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="points">
        <div class="anotation item" v-if="articleItem.annotation">

          <div class="title" @click="isAnotationOpen = !isAnotationOpen">
            <div class="text">
              Анотація
            </div>
            <div class="open">
              <div class="line" :class="isAnotationOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isAnotationOpen">
              {{ articleItem.annotation }}
            </div>
          </transition>

        </div>

        <div class="key-words item" v-if="articleItem.tags.length > 0">

          <div class="title" @click="isKeyWordsOpen = !isKeyWordsOpen">
            <div class="text">
              Ключові слова
            </div>
            <div class="open">
              <div class="line" :class="isKeyWordsOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isKeyWordsOpen">
              <div v-for="(tag, index) in articleItem.tags" :key="index">
                  {{tag.title}}<span v-if="index !== articleItem.tags.length - 1">,&nbsp;</span>
              </div>
              <!-- <div v-for="(word, index) in getProductTags()" :key="index">
                {{ word.title }}<span v-if="index !== getProductTags().length - 1">,&nbsp;</span>
              </div> -->
            </div>
          </transition>

        </div>

        <div class="products item" v-if="articleItem.products.length > 0">

          <div class="title" @click="isProductsOpen = !isProductsOpen">
            <div class="text">
              Згадані продукти
            </div>
            <div class="open">
              <div class="line" :class="isProductsOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isProductsOpen">
              <div class="product-label" v-for="(product, index) in articleItem.products" :key="index"
                   @click="openProductInfoPopup(product)">
                {{ product.title }}
              </div>
            </div>
          </transition>

        </div>

        <div class="diet item" v-if="articleItem.dietDescription">

          <div class="title" @click="isAlgorithmsOpen = !isAlgorithmsOpen">
            <div class="text">
              Дієта розроблена на основі <br> даного матеріалу
            </div>
            <div class="open">
              <div class="line" :class="isAlgorithmsOpen ? '': 'rotated'"></div>
              <div class="line"></div>
            </div>
          </div>

          <transition name="fade">
            <div class="container" v-if="isAlgorithmsOpen">
              <div class="text">
                {{ articleItem.dietDescription }}
              </div>
              <router-link class="go" :to="getRef(articleItem.dietLink)" tag="a">
                  перейти
              </router-link>
            </div>
          </transition>

        </div>

        <div class="actions-block" v-if="includeIsPdf">
            <div class="read-send">
                <div class="read" @click="openLanguagePopup('read')">
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.08079 15.8384L3.07161 11.7677H10.1257C11.152 11.7677 11.9869 10.9329 11.9869 9.90656V8.48851C11.9869 8.48706 11.9869 8.48562 11.9868 8.48418V7.27586C11.9868 6.24951 11.152 5.41468 10.1257 5.41468H3.04891V2.39354C3.04891 1.92362 3.43126 1.54119 3.90097 1.54119H4.11173H4.1707H8.60191C9.52645 1.54119 12.7626 1.54125 13.229 1.5704C13.8696 1.61044 14.3884 2.09218 14.3884 2.77613C14.3884 3.14477 14.388 3.47016 14.3876 3.77718C14.387 4.34197 14.3864 4.84458 14.3884 5.43982C14.3884 5.43992 14.3884 5.44001 14.3884 5.44011L14.3884 15.6065C14.3884 16.0764 14.006 16.4588 13.5363 16.4588H3.90103C3.51606 16.4588 3.18379 16.2055 3.08079 15.8384ZM11.3457 8.5473C11.3457 8.54874 11.3457 8.55019 11.3457 8.55163V9.90656C11.3457 10.5792 10.7983 11.1266 10.1257 11.1266H2.2182C1.84499 11.1266 1.54118 10.8227 1.54118 10.4495V5.86832C1.73914 5.9873 1.97084 6.05586 2.2182 6.05586H10.1257C10.7983 6.05586 11.3457 6.60323 11.3457 7.27586V8.5473ZM2.40776 3.41945H2.2182C1.49124 3.41945 0.9 4.01072 0.9 4.73766V10.4495C0.9 11.1765 1.49124 11.7677 2.2182 11.7677H2.43037L2.43979 15.8818L2.4398 15.8822C2.43997 15.9066 2.44292 15.9308 2.44855 15.9544L2.44856 15.9545C2.60968 16.6288 3.20722 17.1 3.901 17.1H13.5363C14.3598 17.1 15.0295 16.4301 15.0295 15.6065L15.0296 4.9493V4.94369V4.93809V4.93251V4.92694V4.92138V4.91583V4.9103V4.90478V4.89927V4.89378V4.8883V4.88283V4.87737V4.87193V4.8665V4.86108V4.85568V4.85029V4.8449V4.83954V4.83418V4.82884V4.82351V4.81819V4.81288V4.80759V4.8023V4.79703V4.79177V4.78653V4.78129V4.77607V4.77086V4.76566V4.76047V4.75529V4.75013V4.74498V4.73984V4.73471V4.72959V4.72448V4.71938V4.7143V4.70923V4.70416V4.69911V4.69407V4.68904V4.68402V4.67902V4.67402V4.66904V4.66406V4.6591V4.65414V4.6492V4.64427V4.63935V4.63444V4.62954V4.62465V4.61977V4.6149V4.61004V4.60519V4.60035V4.59553V4.59071V4.5859V4.5811V4.57631V4.57154V4.56677V4.56201V4.55726V4.55252V4.54779V4.54307V4.53836V4.53366V4.52897V4.52429V4.51962V4.51496V4.5103V4.50566V4.50102V4.4964V4.49178V4.48718V4.48258V4.47799V4.47341V4.46884V4.46427V4.45972V4.45518V4.45064V4.44611V4.44159V4.43708V4.43258V4.42809V4.4236V4.41913V4.41466V4.4102V4.40575V4.4013V4.39687V4.39244V4.38802V4.38361V4.37921V4.37482V4.37043V4.36605V4.36168V4.35731V4.35296V4.34861V4.34427V4.33994V4.33561V4.33129V4.32698V4.32268V4.31838V4.3141V4.30981V4.30554V4.30127V4.29701V4.29276V4.28851V4.28428V4.28004V4.27582V4.2716V4.26739V4.26318V4.25899V4.25479V4.25061V4.24643V4.24226V4.2381V4.23394V4.22978V4.22564V4.2215V4.21736V4.21324V4.20912V4.205V4.20089V4.19679V4.19269V4.1886V4.18451V4.18043V4.17636V4.17229V4.16823V4.16417V4.16012V4.15608V4.15204V4.148V4.14397V4.13995V4.13593V4.13191V4.12791V4.1239V4.1199V4.11591V4.11192V4.10794V4.10396V4.09999V4.09602V4.09206V4.0881V4.08415V4.0802V4.07625V4.07231V4.06838V4.06444V4.06052V4.05659V4.05268V4.04876V4.04485V4.04095V4.03705V4.03315V4.02926V4.02537V4.02148V4.0176V4.01372V4.00985V4.00598V4.00211V3.99825V3.99439V3.99054V3.98669V3.98284V3.97899V3.97515V3.97131V3.96748V3.96365V3.95982V3.956V3.95217V3.94836V3.94454V3.94073V3.93692V3.93311V3.92931V3.92551V3.92171V3.91791V3.91412V3.91033V3.90654V3.90276V3.89897V3.89519V3.89141V3.88764V3.88387V3.88009V3.87633V3.87256V3.86879V3.86503V3.86127V3.85751V3.85376V3.85V3.84625V3.8425V3.83875V3.835V3.83125V3.82751V3.82377V3.82002V3.81628V3.81255V3.80881V3.80507V3.80134V3.79761V3.79387V3.79014V3.78641V3.78268V3.77896V3.77523V3.7715V3.76778V3.76405V3.76033V3.75661V3.75289V3.74916V3.74544V3.74172V3.738V3.73428V3.73056V3.72685V3.72313V3.71941V3.71569V3.71197V3.70826V3.70454V3.70082V3.6971V3.69339V3.68967V3.68595V3.68223V3.67851V3.6748V3.67108V3.66736V3.66364V3.65992V3.6562V3.65247V3.64875V3.64503V3.64131V3.63758V3.63386V3.63013V3.62641V3.62268V3.61895V3.61522V3.61149V3.60776V3.60402V3.60029V3.59655V3.59282V3.58908V3.58534V3.5816V3.57786V3.57411V3.57037V3.56662V3.56287V3.55912V3.55537V3.55161V3.54786V3.5441V3.54034V3.53658V3.53281V3.52905V3.52528V3.52151V3.51774V3.51396V3.51018V3.5064V3.50262V3.49884V3.49505V3.49126V3.48747V3.48367V3.47987V3.47607V3.47227V3.46847V3.46466V3.46084V3.45703V3.45321V3.44939V3.44557V3.44174V3.43791V3.43408V3.43024V3.4264V3.42255V3.41871V3.41486V3.411V3.40714V3.40328V3.39942V3.39555V3.39168V3.3878V3.38392V3.38004V3.37615V3.37226V3.36836V3.36446V3.36056V3.35665V3.35273V3.34882V3.3449V3.34097V3.33704V3.33311V3.32917V3.32522V3.32128V3.31732V3.31336V3.3094V3.30544V3.30146V3.29749V3.29351V3.28952V3.28553V3.28153V3.27753V3.27352V3.26951V3.26549V3.26147V3.25744V3.25341V3.24937V3.24532V3.24128V3.23722V3.23316V3.22909V3.22502V3.22094V3.21686V3.21277V3.20867V3.20457V3.20046V3.19635V3.19223V3.1881V3.18397V3.17983V3.17569V3.17154V3.16738V3.16322V3.15905V3.15487V3.15069V3.1465V3.1423V3.1381V3.13389V3.12967V3.12545V3.12122V3.11698V3.11274V3.10849V3.10423V3.09996V3.09569V3.09141V3.08713V3.08283V3.07853V3.07422V3.06991V3.06558V3.06125V3.05691V3.05257V3.04821V3.04385V3.03948V3.03511V3.03072V3.02633V3.02193V3.01752V3.0131V3.00868V3.00424V2.9998V2.99535V2.9909V2.98643V2.98196V2.97747V2.97298V2.96848V2.96398V2.95946V2.95493V2.9504V2.94586V2.94131V2.93675V2.93218V2.9276V2.92301V2.91842V2.91381V2.9092V2.90457V2.89994V2.8953V2.89065V2.88599V2.88132V2.87664V2.87195V2.86726V2.86255V2.85783V2.85311V2.84837V2.84362V2.83887V2.8341V2.82933V2.82454V2.81975V2.81494V2.81012V2.8053V2.80046V2.79562V2.79076V2.7859V2.78102V2.77613C15.0296 1.90305 14.4136 0.900037 13.2353 0.900011H9.09805H4.1707H4.11173H3.901C3.07751 0.900011 2.40776 1.56995 2.40776 2.39354V3.41945ZM2.2182 4.06063H2.40776V5.41468H2.2182C1.84499 5.41468 1.54118 5.11087 1.54118 4.73766C1.54118 4.36444 1.84497 4.06063 2.2182 4.06063Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.2"/>
                        <mask id="path-2-inside-1" fill="white">
                        <path d="M9.87948 7.42956C9.99206 7.42956 10.0833 7.33832 10.0833 7.22577C10.0833 7.11322 9.99206 7.02197 9.87948 7.02197H8.8288C8.71622 7.02197 8.625 7.11322 8.625 7.22577V9.81818C8.625 9.93073 8.71622 10.022 8.8288 10.022C8.94137 10.022 9.03259 9.93073 9.03259 9.81818V8.70122H9.79603C9.90861 8.70122 9.99983 8.60997 9.99983 8.49742C9.99983 8.38487 9.90861 8.29363 9.79603 8.29363H9.03259V7.42956H9.87948Z"/>
                        </mask>
                        <path d="M9.87948 7.42956C9.99206 7.42956 10.0833 7.33832 10.0833 7.22577C10.0833 7.11322 9.99206 7.02197 9.87948 7.02197H8.8288C8.71622 7.02197 8.625 7.11322 8.625 7.22577V9.81818C8.625 9.93073 8.71622 10.022 8.8288 10.022C8.94137 10.022 9.03259 9.93073 9.03259 9.81818V8.70122H9.79603C9.90861 8.70122 9.99983 8.60997 9.99983 8.49742C9.99983 8.38487 9.90861 8.29363 9.79603 8.29363H9.03259V7.42956H9.87948Z" fill="#8F67A4"/>
                        <path d="M9.03259 8.70122V7.70122H8.03259V8.70122H9.03259ZM9.03259 8.29363H8.03259V9.29363H9.03259V8.29363ZM9.03259 7.42956V6.42956H8.03259V7.42956H9.03259ZM9.87948 8.42956C10.5444 8.42956 11.0833 7.89051 11.0833 7.22577H9.08328C9.08328 6.78612 9.43969 6.42956 9.87948 6.42956V8.42956ZM11.0833 7.22577C11.0833 6.56102 10.5444 6.02197 9.87948 6.02197V8.02197C9.43969 8.02197 9.08328 7.66542 9.08328 7.22577H11.0833ZM9.87948 6.02197H8.8288V8.02197H9.87948V6.02197ZM8.8288 6.02197C8.16385 6.02197 7.625 6.56102 7.625 7.22577H9.625C9.625 7.66542 9.26859 8.02197 8.8288 8.02197V6.02197ZM7.625 7.22577V9.81818H9.625V7.22577H7.625ZM7.625 9.81818C7.625 10.4829 8.16385 11.022 8.8288 11.022V9.02197C9.26859 9.02197 9.625 9.37853 9.625 9.81818H7.625ZM8.8288 11.022C9.49374 11.022 10.0326 10.4829 10.0326 9.81818H8.03259C8.03259 9.37853 8.389 9.02197 8.8288 9.02197V11.022ZM10.0326 9.81818V8.70122H8.03259V9.81818H10.0326ZM9.03259 9.70122H9.79603V7.70122H9.03259V9.70122ZM9.79603 9.70122C10.461 9.70122 10.9998 9.16217 10.9998 8.49742H8.99983C8.99983 8.05777 9.35624 7.70122 9.79603 7.70122V9.70122ZM10.9998 8.49742C10.9998 7.83267 10.461 7.29363 9.79603 7.29363V9.29363C9.35624 9.29363 8.99983 8.93707 8.99983 8.49742H10.9998ZM9.79603 7.29363H9.03259V9.29363H9.79603V7.29363ZM10.0326 8.29363V7.42956H8.03259V8.29363H10.0326ZM9.03259 8.42956H9.87948V6.42956H9.03259V8.42956Z" fill="#8F67A4" mask="url(#path-2-inside-1)"/>
                        <mask id="path-4-inside-2" fill="white">
                        <path d="M5.75604 7.02197C5.70194 7.02197 5.65004 7.04349 5.61178 7.08181C5.57358 7.12012 5.55214 7.17205 5.55225 7.22617V7.2284V7.22848V9.77609C5.55225 9.79196 5.55423 9.80734 5.55768 9.82214C5.55871 9.87502 5.58015 9.92551 5.61771 9.96282C5.65588 10.0007 5.70751 10.022 5.76129 10.022H5.76205C5.78419 10.0219 6.30694 10.0199 6.5153 10.0162C6.87697 10.0099 7.19897 9.84608 7.42208 9.55493C7.62767 9.28657 7.74092 8.91974 7.74092 8.52199C7.74092 7.6248 7.23831 7.022 6.49025 7.022H5.75604V7.02197ZM7.33333 8.52199C7.33333 9.15334 6.99403 9.60022 6.50818 9.6087C6.38425 9.61088 6.14002 9.61248 5.96437 9.61343C5.96337 9.31608 5.96168 8.77176 5.96168 8.51913C5.96168 8.3077 5.96073 7.73765 5.96016 7.42959H6.49022C6.89784 7.42956 7.33333 7.71656 7.33333 8.52199Z"/>
                        </mask>
                        <path d="M5.75604 7.02197C5.70194 7.02197 5.65004 7.04349 5.61178 7.08181C5.57358 7.12012 5.55214 7.17205 5.55225 7.22617V7.2284V7.22848V9.77609C5.55225 9.79196 5.55423 9.80734 5.55768 9.82214C5.55871 9.87502 5.58015 9.92551 5.61771 9.96282C5.65588 10.0007 5.70751 10.022 5.76129 10.022H5.76205C5.78419 10.0219 6.30694 10.0199 6.5153 10.0162C6.87697 10.0099 7.19897 9.84608 7.42208 9.55493C7.62767 9.28657 7.74092 8.91974 7.74092 8.52199C7.74092 7.6248 7.23831 7.022 6.49025 7.022H5.75604V7.02197ZM7.33333 8.52199C7.33333 9.15334 6.99403 9.60022 6.50818 9.6087C6.38425 9.61088 6.14002 9.61248 5.96437 9.61343C5.96337 9.31608 5.96168 8.77176 5.96168 8.51913C5.96168 8.3077 5.96073 7.73765 5.96016 7.42959H6.49022C6.89784 7.42956 7.33333 7.71656 7.33333 8.52199Z" fill="#8F67A4"/>
                        <path d="M5.75604 7.02197H6.75604V6.02197H5.75604V7.02197ZM5.61178 7.08181L4.90417 6.3752L4.90367 6.37571L5.61178 7.08181ZM5.55225 7.22617H6.55225L6.55224 7.22417L5.55225 7.22617ZM5.55768 9.82214L6.55749 9.80262L6.55544 9.69755L6.53159 9.5952L5.55768 9.82214ZM5.61771 9.96282L4.91291 10.6722L4.91313 10.6724L5.61771 9.96282ZM5.76205 10.022V11.022L5.76573 11.022L5.76205 10.022ZM6.5153 10.0162L6.49787 9.01639L6.49783 9.01639L6.5153 10.0162ZM7.42208 9.55493L8.21582 10.1632L8.2159 10.1631L7.42208 9.55493ZM5.75604 7.022H4.75604V8.022H5.75604V7.022ZM6.50818 9.6087L6.49073 8.60886L6.49064 8.60886L6.50818 9.6087ZM5.96437 9.61343L4.96438 9.61681L4.96777 10.6188L5.96979 10.6134L5.96437 9.61343ZM5.96016 7.42959V6.42959H4.95831L4.96016 7.43144L5.96016 7.42959ZM6.49022 7.42959V8.42959H6.49029L6.49022 7.42959ZM5.75604 6.02197C5.43635 6.02197 5.12992 6.14914 4.90417 6.3752L6.31939 7.78841C6.17017 7.93785 5.96754 8.02197 5.75604 8.02197V6.02197ZM4.90367 6.37571C4.67832 6.6017 4.55161 6.90826 4.55225 7.22818L6.55224 7.22417C6.55267 7.43584 6.46883 7.63854 6.31989 7.78791L4.90367 6.37571ZM4.55225 7.22617V7.2284H6.55225V7.22617H4.55225ZM4.55225 7.2284V7.22848H6.55225V7.2284H4.55225ZM4.55225 7.22848V9.77609H6.55225V7.22848H4.55225ZM4.55225 9.77609C4.55225 9.8758 4.56476 9.9675 4.58377 10.0491L6.53159 9.5952C6.5437 9.64718 6.55225 9.70811 6.55225 9.77609H4.55225ZM4.55787 9.84167C4.56394 10.1523 4.68993 10.4507 4.91291 10.6722L6.3225 9.2534C6.47037 9.40031 6.55349 9.59776 6.55749 9.80262L4.55787 9.84167ZM4.91313 10.6724C5.13884 10.8965 5.44382 11.022 5.76129 11.022V9.02197C5.9712 9.02197 6.17293 9.1049 6.32228 9.25319L4.91313 10.6724ZM5.76129 11.022H5.76205V9.02197H5.76129V11.022ZM5.76573 11.022C5.7845 11.0219 6.31577 11.0199 6.53277 11.0161L6.49783 9.01639C6.29811 9.01988 5.78389 9.02189 5.75837 9.02198L5.76573 11.022ZM6.53273 11.0161C7.20444 11.0044 7.81032 10.6924 8.21582 10.1632L6.62834 8.94668C6.58761 8.99982 6.5495 9.01549 6.49787 9.01639L6.53273 11.0161ZM8.2159 10.1631C8.57775 9.69075 8.74092 9.0994 8.74092 8.52199H6.74092C6.74092 8.74008 6.67758 8.88239 6.62826 8.94678L8.2159 10.1631ZM8.74092 8.52199C8.74092 7.89303 8.5643 7.27506 8.16416 6.79515C7.75103 6.29967 7.1547 6.022 6.49025 6.022V8.022C6.54088 8.022 6.56814 8.03165 6.58106 8.03764C6.59393 8.0436 6.60953 8.05372 6.62806 8.07594C6.66624 8.12173 6.74092 8.25375 6.74092 8.52199H8.74092ZM6.49025 6.022H5.75604V8.022H6.49025V6.022ZM6.75604 7.022V7.02197H4.75604V7.022H6.75604ZM6.33333 8.52199C6.33333 8.66665 6.29396 8.71073 6.30652 8.6942C6.31422 8.68406 6.33547 8.6608 6.3746 8.64011C6.41519 8.61864 6.45733 8.60944 6.49073 8.60886L6.52563 10.6086C7.7787 10.5867 8.33333 9.44621 8.33333 8.52199H6.33333ZM6.49064 8.60886C6.37404 8.6109 6.13645 8.61248 5.95896 8.61345L5.96979 10.6134C6.14358 10.6125 6.39446 10.6109 6.52572 10.6085L6.49064 8.60886ZM6.96437 9.61005C6.96336 9.31214 6.96168 8.7697 6.96168 8.51913H4.96168C4.96168 8.77381 4.96338 9.32002 4.96438 9.61681L6.96437 9.61005ZM6.96168 8.51913C6.96168 8.30656 6.96073 7.73543 6.96016 7.42774L4.96016 7.43144C4.96074 7.73986 4.96168 8.30884 4.96168 8.51913H6.96168ZM5.96016 8.42959H6.49022V6.42959H5.96016V8.42959ZM6.49029 8.42959C6.47582 8.42959 6.45146 8.42712 6.42068 8.41474C6.38761 8.40143 6.35568 8.37992 6.33124 8.35355C6.30687 8.32725 6.30515 8.31265 6.3112 8.33062C6.31803 8.3509 6.33333 8.40954 6.33333 8.52199H8.33333C8.33333 7.94163 8.17391 7.39945 7.79803 6.99394C7.42111 6.58731 6.9286 6.42956 6.49015 6.42959L6.49029 8.42959Z" fill="#8F67A4" mask="url(#path-4-inside-2)"/>
                        <mask id="path-6-inside-3" fill="white">
                        <path d="M3.20253 7.00003C3.14872 7.00003 3.09712 7.02144 3.0591 7.05956C3.02136 7.09742 3.00019 7.14866 3.00005 7.2021C3.00005 7.20226 3 7.2024 3 7.20253V9.7975C3 9.90933 3.09064 10 3.2025 10C3.31437 10 3.40501 9.90933 3.40501 9.7975V8.8717C3.57306 8.87078 3.80615 8.86962 3.92506 8.86962C4.44842 8.86962 4.87419 8.45028 4.87419 7.93481C4.87419 7.41935 4.44839 7 3.92506 7H3.20253V7.00003ZM4.46921 7.93484C4.46921 8.22202 4.22002 8.46464 3.92509 8.46464C3.80683 8.46464 3.57697 8.46578 3.40892 8.4667C3.408 8.29413 3.40684 8.0555 3.40684 7.93484C3.40684 7.83305 3.4062 7.58451 3.40566 7.40503H3.92509C4.22002 7.40503 4.46921 7.64763 4.46921 7.93484Z"/>
                        </mask>
                        <path d="M3.20253 7.00003C3.14872 7.00003 3.09712 7.02144 3.0591 7.05956C3.02136 7.09742 3.00019 7.14866 3.00005 7.2021C3.00005 7.20226 3 7.2024 3 7.20253V9.7975C3 9.90933 3.09064 10 3.2025 10C3.31437 10 3.40501 9.90933 3.40501 9.7975V8.8717C3.57306 8.87078 3.80615 8.86962 3.92506 8.86962C4.44842 8.86962 4.87419 8.45028 4.87419 7.93481C4.87419 7.41935 4.44839 7 3.92506 7H3.20253V7.00003ZM4.46921 7.93484C4.46921 8.22202 4.22002 8.46464 3.92509 8.46464C3.80683 8.46464 3.57697 8.46578 3.40892 8.4667C3.408 8.29413 3.40684 8.0555 3.40684 7.93484C3.40684 7.83305 3.4062 7.58451 3.40566 7.40503H3.92509C4.22002 7.40503 4.46921 7.64763 4.46921 7.93484Z" fill="#8F67A4"/>
                        <path d="M3.20253 7.00003V8.00003H4.20253V7.00003H3.20253ZM3.0591 7.05956L2.35099 6.35346L2.35099 6.35347L3.0591 7.05956ZM3.00005 7.2021L2.00005 7.19957V7.2021H3.00005ZM3.40501 8.8717L3.39955 7.87172L2.40501 7.87715V8.8717H3.40501ZM3.20253 7V6H2.20253V7H3.20253ZM3.40892 8.4667L2.40894 8.47202L2.41426 9.47214L3.41439 9.46668L3.40892 8.4667ZM3.40566 7.40503V6.40503H2.40264L2.40566 7.40804L3.40566 7.40503ZM3.20253 6.00003C2.88299 6.00003 2.57662 6.1272 2.35099 6.35346L3.76721 7.76567C3.61762 7.91568 3.41444 8.00003 3.20253 8.00003V6.00003ZM2.35099 6.35347C2.12616 6.57894 2.00086 6.8834 2.00006 7.19957L4.00005 7.20462C3.99952 7.41393 3.91655 7.6159 3.76722 7.76566L2.35099 6.35347ZM2.00005 7.2021C2.00005 7.1466 2.0047 7.10067 2.00898 7.06886C2.0111 7.05306 2.01324 7.04009 2.01475 7.03133C2.0162 7.02302 2.01745 7.01646 2.0176 7.01568C2.01764 7.01547 2.01771 7.01509 2.01766 7.01536C2.01764 7.01546 2.01755 7.01593 2.01744 7.01652C2.01722 7.01768 2.01675 7.0202 2.01616 7.0234C2.01504 7.02959 2.01295 7.04135 2.01076 7.05619C2.00854 7.07122 2.00588 7.09155 2.00377 7.11571C2.00166 7.14001 2 7.16929 2 7.20253H4C4 7.23573 3.99834 7.26499 3.99623 7.28925C3.99413 7.31338 3.99147 7.33367 3.98926 7.34867C3.98707 7.36348 3.98499 7.3752 3.98387 7.38135C3.98329 7.38454 3.98282 7.38704 3.9826 7.38818C3.98249 7.38877 3.98241 7.38923 3.98239 7.38931C3.98234 7.38958 3.98241 7.38919 3.98246 7.38897C3.98261 7.38815 3.98387 7.38156 3.98532 7.37321C3.98684 7.36442 3.98898 7.35141 3.99111 7.33557C3.9954 7.30368 4.00005 7.25767 4.00005 7.2021H2.00005ZM2 7.20253V9.7975H4V7.20253H2ZM2 9.7975C2 10.4615 2.53827 11 3.2025 11V9C3.64301 9 4 9.35713 4 9.7975H2ZM3.2025 11C3.86674 11 4.40501 10.4615 4.40501 9.7975H2.40501C2.40501 9.35713 2.762 9 3.2025 9V11ZM4.40501 9.7975V8.8717H2.40501V9.7975H4.40501ZM3.41047 9.87169C3.5794 9.87076 3.80947 9.86962 3.92506 9.86962V7.86962C3.80284 7.86962 3.56672 7.8708 3.39955 7.87172L3.41047 9.87169ZM3.92506 9.86962C4.98632 9.86962 5.87419 9.01684 5.87419 7.93481H3.87419C3.87419 7.92476 3.87648 7.91338 3.88087 7.90318C3.88494 7.89371 3.8899 7.88726 3.89417 7.88306C3.90274 7.87461 3.91497 7.86962 3.92506 7.86962V9.86962ZM5.87419 7.93481C5.87419 6.85277 4.98627 6 3.92506 6V8C3.91495 8 3.90272 7.995 3.89417 7.98657C3.8899 7.98238 3.88495 7.97593 3.88087 7.96646C3.87648 7.95626 3.87419 7.94487 3.87419 7.93481H5.87419ZM3.92506 6H3.20253V8H3.92506V6ZM2.20253 7V7.00003H4.20253V7H2.20253ZM3.46921 7.93484C3.46921 7.78353 3.53468 7.66442 3.61013 7.59096C3.68552 7.51756 3.79546 7.46464 3.92509 7.46464V9.46464C4.747 9.46464 5.46921 8.79927 5.46921 7.93484H3.46921ZM3.92509 7.46464C3.80353 7.46464 3.5707 7.4658 3.40346 7.46671L3.41439 9.46668C3.58325 9.46576 3.81013 9.46464 3.92509 9.46464V7.46464ZM4.40891 8.46138C4.40799 8.28793 4.40684 8.05227 4.40684 7.93484H2.40684C2.40684 8.05874 2.40802 8.30034 2.40894 8.47202L4.40891 8.46138ZM4.40684 7.93484C4.40684 7.83123 4.40619 7.58104 4.40565 7.40203L2.40566 7.40804C2.4062 7.58798 2.40684 7.83487 2.40684 7.93484H4.40684ZM3.40566 8.40503H3.92509V6.40503H3.40566V8.40503ZM3.92509 8.40503C3.79549 8.40503 3.68555 8.35214 3.61014 8.27872C3.53467 8.20524 3.46921 8.08612 3.46921 7.93484H5.46921C5.46921 7.07035 4.74697 6.40503 3.92509 6.40503V8.40503Z" fill="#8F67A4" mask="url(#path-6-inside-3)"/>
                    </svg>
                    читати
                </div>
                <div class="send" @click="openLanguagePopup('send2')">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.0315 9.02942L17.0622 8.99573L17.0315 8.96204L9.7397 0.966308L9.65276 0.87097V1V5.73955H8.85571C6.74419 5.73955 4.75869 6.56196 3.26555 8.0551C1.77241 9.54824 0.95 11.5337 0.95 13.6454V17V17.129L1.03693 17.0337L2.43635 15.5004C4.28757 13.4722 6.91073 12.2937 9.65276 12.253V16.9916V17.1206L9.7397 17.0253L17.0315 9.02942ZM15.658 8.99573L10.6903 14.443V11.2644V11.2144H10.6403H9.79907C6.86704 11.2144 4.04602 12.3946 1.98762 14.4673V13.6454C1.98762 11.8107 2.70196 10.086 3.99922 8.78877C5.29649 7.49151 7.02107 6.77717 8.85571 6.77717H10.6403H10.6903V6.72717V3.54858L15.658 8.99573Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
                    </svg>
                    надіслати
                </div>
            </div>
            <div class="download" @click="openLanguagePopup('download')">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12.4436H12" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                    <path d="M6.46484 8.08519V1" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                    <path d="M9.68072 5.66956L6.46463 8.85293L3.24854 5.66956" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
                завантажити
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ProductPopup from '../library-items/popups/product-popup';
import LanguagePopup from '../library-items/popups/language-popup';

export default {
  props: ['articleItem'],
  components: {
    'product-popup': ProductPopup,
    'language-popup': LanguagePopup
  },
  data: () => ({
    isAnotationOpen: false,
    isKeyWordsOpen: false,
    isProductsOpen: false,
    isAlgorithmsOpen: false,

    includeIsPdf : false,
    excludeIsPdf : false,

    isProductInfoOpen: false,
    action: '',

    productInfo: {},
    productTestInfo: {
      name: 'Суміш суха Nutrilon Пепті',
      description: 'комплексне рішення при харчовій алергії на білок коров’ячого молока',
      useFor: 'Алергія на БКМ',
      image: ''
    },
  }),
  created(){
    try{

        this.articleItem.products.sort((a, b) => {
            if(a.position < b.position) { return -1; }
            if(a.position > b.position) { return 1; }
            return 0;
        })
    }
    catch(e){}

    try{
      this.includeIsPdf = this.checkIsPdf(this.articleItem.includeRation.name);
    }
    catch(e){}

    try{
      this.excludeIsPdf = this.checkIsPdf(this.articleItem.excludeRation.name);
    }
    catch(e){}
  },
  mounted(){
    const UNAUTHORIZED = 401;
    axios.interceptors.response.use(
      response => response,
      error => {
        const {status} = error.response;
        if (status === UNAUTHORIZED) {
          sessionStorage.removeItem('key');
        }
        return Promise.reject(error);
      }
    );
  },
  methods: {
    checkIsPdf(path){
      let extension = path.substring(path.length - 3);

      if(extension === 'pdf'){
       return true;
      }
      else
        return false;
    },
    sendToServerScreen(link) {
      document
          .getElementById("viber_share")
          .setAttribute(
              "href",
              "https://3p3x.adj.st/?adjust_t=u783g1_kw9yml&adjust_fallback=https%3A%2F%2Fwww.viber.com%2F%3Futm_source%3DPartner%26utm_medium%3DSharebutton%26utm_campaign%3DDefualt&adjust_campaign=Sharebutton&adjust_deeplink=" +
              encodeURIComponent(
                  "viber://forward?text=" +
                  encodeURIComponent(link)
              )
          );
      document.getElementById("viber_share").click();
    },
    getRef(str){
      return str.substring(6);
    },
    getProductTags() {
      let tags = [];

      if(this.articleItem.products){
        for (let i = 0; i < this.articleItem.products.length; i++) {
          tags = tags.concat(this.articleItem.products[i].tags)
        }
      }

      return tags;
    },
    getLangCount(){
      let count = 0;
      count = this.includeIsPdf ? count + 1 : count;
      count = this.excludeIsPdf ? count + 1 : count;

      return count;
    },
    getSingleContent(){
      if(this.includeIsPdf)
          return this.articleItem.includeRation;
      if(this.excludeIsPdf)
          return this.articleItem.excludeRation;
    },
    openLanguagePopup(action){
      let langCount = this.getLangCount();
      if(langCount > 1){
          this.action = action;
          this.removeScroll();
      }
      else{
          let content = this.getSingleContent();
          switch(action){
              case 'read' : {
                  let a  = document.createElement('a');
                  a.href = this.$root.globalUrl + content.name;
                  a.target = "_blank";
                  a.click();
              }
              break;
              case 'download' : {
                  let a  = document.createElement('a');
                  a.href = this.$root.globalUrl + content.name;
                  a.setAttribute('download', "download");
                  a.click();
              }
              break;
              case 'send2' : {
                  document
                      .getElementById("viber_share")
                      .setAttribute(
                          "href",
                          "https://3p3x.adj.st/?adjust_t=u783g1_kw9yml&adjust_fallback=https%3A%2F%2Fwww.viber.com%2F%3Futm_source%3DPartner%26utm_medium%3DSharebutton%26utm_campaign%3DDefualt&adjust_campaign=Sharebutton&adjust_deeplink=" +
                          encodeURIComponent(
                              "viber://forward?text=" +
                              encodeURIComponent(this.$root.globalUrl + content.name)
                          )
                      );
                  document.getElementById("viber_share").click();
              }
              break;
          }
      }      
    },
    openProductInfoPopup(product) {

      this.removeScroll();

      this.productInfo = product;

      this.isProductInfoOpen = true;
    },
    // openLanguagePopup(action) {
    //   this.action = action;
    //   this.removeScroll();
    // },
    closePopup() {
      this.isProductInfoOpen = false;
      this.action = '';
      this.addScroll();
    },
    removeScroll() {
      if(window.screen.width > 426){
        document.getElementsByTagName("body")[0].style.overflow = "visible";
      }
      else{
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
      }
    },
    addScroll() {
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
  }
}
</script>

<style lang="scss" scoped>
.scientific-article {
  padding: 15px 15px 60px;
  border-radius: 4px;

  .article-header {
    background: #EFE1F7;
    padding: 10px 15px 15px 15px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .article-type {
      font-size: 12px;
      color: #4A2A80;
    }
  }

  .article-content {
    background: #FFFFFF;

    .article-title {
      padding: 20px 15px;

      display: flex;
      flex-direction: row;

      align-items: center;

      .image {
        padding-right: 14px;
      }

      .title {
        font-weight: 600;
        font-size: 13px;
        line-height: 130%;
        color: #4A2A80;
      }
    }

    .usefull-info {
      padding: 5px 18px 8px;
      background: rgba(143, 103, 164, 0.6);
      color: #FFFFFF;
      font-size: 10px;
      line-height: 14px;
    }

    .recomendations {
      padding: 16px 15px 0;

      .year {
        display: flex;
        flex-direction: row;
        align-items: center;

        padding-bottom: 34px;

        .icon {
          display: flex;
          align-items: center;

          padding-right: 8px;
        }

        .text {
          font-size: 10px;
          line-height: 14px;
          color: #4A2A80;
        }
      }

      .images-conteainer {
        .image-block {
          img {
            width: 100%;
            height: auto;
          }

          .action-buttons {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            padding-top: 18px;
            padding-bottom: 40px;

            .download, .send {
              font-weight: bold;
              font-size: 15px;
              line-height: 20px;
              text-transform: uppercase;

              border-radius: 4px;

              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;

              // width: 125px;
              width: 45%;
              height: 40px;

              svg {
                margin-right: 9px;
              }
            }

            .download {
              background: #8F67A4;
              color: #FFFFFF;

              margin-right: 11px;
            }

            .send {
              border: 1px solid #8F67A4;
              box-sizing: border-box;

              color: #8F67A4;
            }
          }
        }
      }
    }

    .points {
      .item {
        padding: 13px 20px 17px 15px;

        border-bottom: 1px solid #EFE1F7;
        cursor: pointer;
        .title {
          font-weight: 600;
          font-size: 14px;
          color: #4A2A80;

          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          .text {
            display: flex;
          }

          .open {
            width: 20px;
            height: 20px;


            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .line {
              width: 20px;
              height: 2px;
              background: #8F67A4;

              position: absolute;
              transition: transform 500ms ease;
            }

            .rotated {
              transform: rotate(-90deg);
              transition: transform 500ms ease;
            }
          }
        }

        .container {
          padding-top: 10px;

          font-size: 12px;
          color: #4A2A80;
          font-weight: 300;
          line-height: 135%;
        }

      }

      .key-words, .products {
        .container {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }
      }

      .products {
        .container {
          padding-top: 20px;

          .product-label {
            display: flex;

            margin-right: 10px;
            margin-bottom: 10px;

            padding: 4px 4px;
            border: 0.606867px solid #4A2A80;
            box-sizing: border-box;
            border-radius: 4px;
          }
        }
      }

      .diet {
        .container {
          padding-top: 20px;

          .text {
            padding-bottom: 11px;
          }

          .go {
            flex-grow: 1;
            padding: 10px;

            display: block;

            width: 120px;
            text-align: center;

            color: #8F67A4;
            text-transform: uppercase;
            font-weight: 600;
            font-size: 13px;

            border: 1px solid #8F67A4;
            box-sizing: border-box;
            border-radius: 4px;
          }
        }
      }

      .actions-block{
            padding: 30px 15px;

            .read-send{
                display: flex;
                flex-direction: row;
                padding-bottom: 19px;

                .read, .send{
                    flex-grow: 1;
                    flex-basis: 0;

                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    padding: 11px 0;

                    border: 1px solid #8F67A4;
                    box-sizing: border-box;
                    border-radius: 4px;

                    color: #8F67A4;
                    text-transform: uppercase;
                    font-weight: bold;
                    font-size: 13px;
                    cursor: pointer;

                    svg{
                        margin-right: 9px;
                    }
                }

                .read{
                    margin-right: 10px;
                }
            }

            .download{
                padding: 10px 0;
                background: #8F67A4;
                border-radius: 4px;
                text-align: center;
                font-weight: bold;
                font-size: 15px;
                line-height: 20px;
                text-transform: uppercase;
                color: #FFFFFF;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;

                svg{
                    margin-right: 10px;
                }
            }
        }
    }
  }


}
</style>
